/*
 * Copyright (C) 2023 SADE Innovations Oy - All Rights Reserved
 *
 * NOTICE: This software is owned by SADE Innovations Oy and licensed under SADE Booster license.
 * All dissemination, usage, modification, copying, reproduction, selling and distribution of the
 * software and its intellectual and technical concepts are strictly forbidden without a valid license.
 * Such license can be obtained by issuing a SADE Booster License agreement from SADE Innovations Oy
 * (https://sadeinnovations.com).
 */

import React, { FunctionComponent, ReactElement } from "react";
import { Typography } from "@material-ui/core";

interface Props {
  item: { name: string; id: string };
  active?: boolean;
  "data-testid": string;
}

export const AdminCellItem: FunctionComponent<Props> = (props: Props): ReactElement => {
  return (
    <>
      <Typography color="textPrimary" data-testid={props["data-testid"]}>
        {props.active ? <b>{props.item.name}</b> : props.item.name}
      </Typography>
      <Typography variant="body2" color="textSecondary" data-testid={`${props["data-testid"]}-id`}>
        {props.item.id}
      </Typography>
    </>
  );
};
